import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';

@Component({
    selector: 'app-voorraadmutatie',
    templateUrl: './voorraadmutatie.page.html',
    styleUrls: ['./voorraadmutatie.page.scss'],
    standalone: false
})
export class VoorraadmutatiePage implements OnInit {

    selected = {
        'background-color': '#00f',
        color: '#fff',
        padding: '10px',
        margin: '10px',
    };
    greystyle = {
        'background-color': '#eee',
        padding: '10px',
        margin: '10px',
        'text-decoration': 'line-through',
    };

    mutValue = 0;
    colorBij: any = this.greystyle;
    colorAf: any = this.greystyle;
    colorCheck: any = this.selected;
    artnr = '';
    artdes = '';
    voorraad = '';

    inpArtnr = '';

    @ViewChild('inpArtnrElt', { static: true }) inputArt: ElementRef;

    constructor(
        private router: Router,
        public global: GlobalService,
        private ajax: AjaxService,
    ) { }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.artnr = '';
        this.artdes = '';
        this.voorraad = '';
        this.inpArtnr = '';
        this.inputArt.nativeElement.focus();
    }

    doMut(delta) {
        this.mutValue = delta;
        this.colorBij = (this.mutValue === 1) ? this.selected : this.greystyle;
        this.colorCheck = (this.mutValue === 0) ? this.selected : this.greystyle;
        this.colorAf = (this.mutValue === -1) ? this.selected : this.greystyle;
        this.inputArt.nativeElement.focus();
    }

    artChanged(nwArtNr) {
        console.log('onChangeArt: ' + nwArtNr);
        this.ajax.get('artList', { req: nwArtNr })
        .then((data: any) => {
            if (!data.login) {
                this.router.navigateByUrl('login');
            } else {
                console.log('artList = ', data);
                if (data.txt.length === 1
                && data.txt[0].nr.toLowerCase() === nwArtNr.toLowerCase()) {
                    console.log('found: ', data.txt[0]);
                    this.artnr = data.txt[0].nr;
                    this.artdes = data.txt[0].des;
                    this.voorraad = '';

                    this.inpArtnr = '';
                    this.inputArt.nativeElement.focus();

                    this.ajax.get('artData', { req: this.artnr })
                    .then((artdata: any) => {
                        if (!artdata.login) {
                            this.router.navigateByUrl('login');
                        } else {
                            console.log('got1 = ', artdata);
                            this.voorraad = artdata.vrd;
                            if (this.mutValue !== 0) {
                                this.ajax.get('artTelling', {
                                    req: this.artnr,
                                    qty: parseFloat(this.voorraad) + this.mutValue
                                })
                                .then((teldata: any) => {
                                    if (!teldata.login) {
                                        this.router.navigateByUrl('login');
                                    } else {
                                        console.log('mutatie = ', this.mutValue, teldata);
                                        this.voorraad = String(parseFloat(this.voorraad) + this.mutValue);
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
    }
}
